'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
export type RadioGroupProps = Omit<Headless.RadioGroupProps, 'as' | 'className'> & {
  className?: string;
};
export function RadioGroup(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("space-y-3 **:data-[slot=label]:font-normal", "has-data-[slot=description]:space-y-4 has-data-[slot=description]:**:data-[slot=label]:font-medium", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Headless.RadioGroup data-slot="control" {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}